import { transformNull } from '../../common/utils';
import {
  DataObjectOutputType,
  DataObjectType,
  VersionDataType,
  VersionQueryDtoType,
} from '../types';
import { VersionDataSchema } from '../schema';
import { z } from 'zod/v3';

export const DataObjectDirectoryDtoSchema = z.object({
  id: z.number(),
  activeVersionId: z.number().nullable(),
  dataObjectType: z.nativeEnum(DataObjectType),
  code: transformNull<string>(z.string(), ''),
  name: transformNull<string>(z.string(), ''),
  outputTypeCode: z.nativeEnum(DataObjectOutputType).nullable(),
  dataObjectGroupCode: transformNull<string>(z.string(), ''),
  groupSubgroupName: transformNull<string>(z.string(), ''),
  frequencyName: transformNull<string>(z.string(), ''),
  sourceNames: transformNull<string>(z.string(), ''),
  versions: transformNull<VersionDataType[], VersionQueryDtoType[]>(
    z.array(VersionDataSchema),
    [],
  ),
});

export const DataObjectDirectorySchema = DataObjectDirectoryDtoSchema.transform(
  (data) => ({
    ...data,
    key: data.id,
    activeVersion: data.versions.find(
      (version) => version.id === data.activeVersionId,
    ),
  }),
);
